import React from 'react';
import { CurrentDossierProvider } from '@europrocurement/l2d-modules';
import { useParams } from 'react-router';
import DossierInfoValidation from './DossierInfoValidation';

const InfoValidation: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    if (!idDossier) {
        console.warn(`Dossier non trouvé paramètres url:  ${idDossier}`);
        throw new Error(`Dossier non trouvé paramètres url:  ${idDossier}`);
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <DossierInfoValidation />
        </CurrentDossierProvider>
    );
};

export default InfoValidation;
